import { render, staticRenderFns } from "./RbSettings.vue?vue&type=template&id=587b41a6&scoped=true&"
import script from "./RbSettings.vue?vue&type=script&lang=js&"
export * from "./RbSettings.vue?vue&type=script&lang=js&"
import style0 from "./RbSettings.vue?vue&type=style&index=0&id=587b41a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587b41a6",
  null
  
)

export default component.exports